/**
 * Formattazione byte condivisa dalle sezioni admin (quota piano, peso database).
 * I valori bigint di Postgres possono arrivare come stringa a seconda del driver:
 * usare `toNumber()` prima di formattare.
 */
export function formatBytes(bytes: number | null): string {
  if (bytes == null || Number.isNaN(bytes)) return "—";
  if (bytes >= 1073741824) return `${(bytes / 1073741824).toFixed(1)} GB`;
  if (bytes >= 1048576) return `${(bytes / 1048576).toFixed(1)} MB`;
  if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${bytes} B`;
}

/** Cast difensivo: i bigint Postgres arrivano come number oppure come string. */
export function toNumber(value: number | string | null | undefined): number {
  if (value == null) return 0;
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : 0;
}
